import { BaseClient } from 'src/common-services/clients/base-client'
import {
  AMLocation,
  AMMobilityBrandDayOfWeekVisits,
  AMMobilityBrandDayOfWeekVisitsRequest,
  AMMobilityBrandVisits,
  AMMobilityBrandVisitsRequest,
  AMMobilityDateRange,
} from 'src/common-services/types/alphamap'

export class BrandsMobilityClient extends BaseClient {
  getBrandVisits(request: AMMobilityBrandVisitsRequest): Promise<AMMobilityBrandVisits[]> {
    return this.call<AMMobilityBrandVisits[]>(`/v2/mobility/brands/${request.id}/visits`, 'POST', {
      data: {
        from: request.from,
        to: request.to,
      },
    })
  }

  getBrandDayOfWeekVisits(request: AMMobilityBrandDayOfWeekVisitsRequest): Promise<AMMobilityBrandDayOfWeekVisits> {
    return this.call<AMMobilityBrandDayOfWeekVisits>(`/v2/mobility/brands/${request.id}/day-of-week-visits`, 'POST', {
      data: {
        date: request.date,
      },
    })
  }

  getValidVisitsDateRange(id: string): Promise<AMMobilityDateRange> {
    return this.call<AMMobilityDateRange>(`/v2/mobility/brands/${id}/valid-visits-date-range`, 'GET')
  }

  getValidDayOfWeekVisitsDateRange(id: string): Promise<AMMobilityDateRange> {
    return this.call<AMMobilityDateRange>(`/v2/mobility/brands/${id}/valid-day-of-week-visits-date-range`, 'GET')
  }

  getBrandLocation(id: string): Promise<AMLocation[]> {
    return this.call<AMLocation[]>(`/v2/mobility/brands/${id}/locations`, 'GET')
  }
}
